import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';
import { useState, useEffect } from 'react'

export const PageShop = () => {

  const [messages, setMessages] = useState<string[]>([])

  useEffect(() => {
    const onMessage = (e: any) => {
      const { origin, data } = e
      if (!origin.includes('ans35.cafe24.com')) { return }

      const { eventName, eventParameters } = JSON.parse(data)

      console.log('[GA4]', eventName, eventParameters)

      const nextMessages = [...messages, eventName]
      setMessages(nextMessages)
    }

    window.addEventListener('message', onMessage)

    return () => {
      window.removeEventListener('message', onMessage)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>고객을 끌어오는 애널리틱스4 쇼핑몰</title>
      </Helmet>
      <div className={styles.container}>
        <iframe className={styles.iframe} src="https://ans35.cafe24.com"></iframe>
      </div>
      <div className={styles.messageList}>
        {
          messages.map((message, i) => {
            return (<p key={i}>{message}</p>)
          })
        }
      </div>
    </>
  )
}